import { VideoCard } from "@/components/video/VideoCard";
import type { VideoCardDisplay } from "@/components/video/types";
import { cn } from "@/lib/utils";

export type VideoCardRowProps<T extends VideoCardDisplay = VideoCardDisplay> = {
  title: string;
  subtitle?: string;
  items: T[];
  onItemClick?: (item: T) => void;
  className?: string;
};

export function VideoCardRow<T extends VideoCardDisplay>({
  title,
  subtitle,
  items,
  onItemClick,
  className,
}: VideoCardRowProps<T>) {
  return (
    <section className={cn("rounded-2xl border border-border bg-card p-5 md:p-6", className)}>
      <h2 className="font-display text-2xl font-bold">{title}</h2>
      {subtitle ? <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p> : null}
      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <VideoCard
            key={item.id}
            {...item}
            onClick={onItemClick && !item.to ? () => onItemClick(item) : undefined}
          />
        ))}
      </div>
    </section>
  );
}
